// css
import '~/shuttle.css'

// js
import Alpine from 'alpinejs'
import privacyConsent from './alpine/privacyConsent'
import vroomvroomBanner from './alpine/vroomvroomBanner'

window.Alpine = Alpine
Alpine.data('privacyConsent', privacyConsent)
Alpine.data('vroomvroomBanner', vroomvroomBanner)
Alpine.start()
